import React, { useEffect } from "react";
// import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { isAuthenticated } from "../../services/Auth";
import { resolveHomeRoute } from "../../utilities/localizaMenu";

const Security: React.FC = () => {
    const navigate = useNavigate();
    const { userEmail } = useAuth();

    useEffect(() => {
        if (isAuthenticated()) {
            // Usuários da Localiza caem na dashboard do POC; os demais, no Início
            // do Modulare (gambiarra temporária — ver utilities/localizaMenu.ts).
            navigate(resolveHomeRoute(userEmail));
        } else  {
            navigate("/login");
        }
    }, [navigate, userEmail]);

    return <div />;
};

export default Security;
